<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ $route.params.id ? "Editar Usuário" : "Adicionar Usuário" }}
              </div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent="save">
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Name">
                          <span class="required">*</span> Nome:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="text"
                          id="Name"
                          class="form-control"
                          v-model="users.usuario_nome"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="loginInput">
                          <span class="required">*</span> Login:
                        </label>
                        <div class="d-flex align-items-center">
                          <input
                            v-if="!cpfLoginMode"
                            autocomplete="new-password"
                            type="text"
                            id="loginInput"
                            class="form-control"
                            v-model="users.login"
                          />
                          <input
                            v-else
                            type="tel"
                            id="loginInput"
                            class="form-control"
                            :value="cpfLogin"
                            placeholder="000.000.000-00"
                            maxlength="14"
                            @input="onCpfInput"
                          />
                          <small
                            class="mx-2"
                            style="font-size: 11px; white-space: nowrap"
                            >CPF</small
                          >
                          <toggle-button
                            v-model="cpfLoginMode"
                            color="#15488A"
                            :height="20"
                            :sync="true"
                          />
                        </div>
                        <small v-if="cpfError" class="text-danger">{{
                          cpfError
                        }}</small>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="inputUser">
                          <span class="required">*</span> Nível de acesso:
                        </label>
                        <select class="form-control" v-model="users.perfil_id">
                          <option :value="null">Selecione</option>
                          <option
                            v-for="perfil_usuario in filteredPerfis"
                            :key="perfil_usuario.perfil_id"
                            :value="perfil_usuario.perfil_id"
                          >
                            {{ perfil_usuario.perfil_nome }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-4">
                        <label for="inputGroup">Grupo:</label>
                        <select
                          class="form-control"
                          v-model="users.group_id"
                          @change="onGroupChange"
                        >
                          <option :value="null">Nenhum</option>
                          <option
                            v-for="group in filteredGroups"
                            :key="group.group_id"
                            :value="group.group_id"
                          >
                            {{ group.group_nome }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-4">
                        <label for="inputCompany">
                          <span class="required">*</span> Empresa:
                        </label>

                        <input
                          v-if="isGestorLogged || isGestorOperacionalLogged"
                          type="text"
                          class="form-control"
                          :value="loggedCompanyName"
                          readonly
                        />

                        <select
                          v-else
                          class="form-control"
                          v-model="users.company_id"
                          @change="onChangeCompany"
                        >
                          <option :value="null">Selecione</option>
                          <option
                            v-for="company in filteredCompanies"
                            :key="company.id"
                            :value="company.id"
                          >
                            {{ company.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-8">
                        <label for="inputUnits">Unidades:</label>
                        <v-select
                          id="inputUnits"
                          v-model="users.unit_ids"
                          :options="filteredUnits"
                          :reduce="(unit) => unit.id"
                          label="name"
                          multiple
                          placeholder="Selecione uma ou mais unidades"
                        />
                      </div>

                      <div class="form-group col-md-2">
                        <label>&nbsp;</label><br />
                        <button
                          type="button"
                          class="btn btn-primary btn-block"
                          @click="selectAllUnits"
                          :disabled="allUnitsSelected"
                        >
                          <i class="fas fa-check-double"></i> Todas
                        </button>
                      </div>

                      <div class="form-group col-md-2">
                        <label>Status do Usuário</label><br />
                        <toggle-button
                          v-model="statusBoolean"
                          color="#15488A"
                          :height="25"
                        />
                        &nbsp;<b>{{ statusBoolean ? "Ativo" : "Inativo" }}</b>
                      </div>
                    </div>

                    <div class="row" v-if="$route.params.id">
                      <div class="col-md-12 mb-2">
                        <button
                          type="button"
                          class="btn btn-add"
                          @click="toggleFormSenha"
                        >
                          <i class="fas fa-key"></i> Alterar Senha
                        </button>
                      </div>
                    </div>

                    <div class="form-row" v-if="change_password">
                      <div class="form-group col-md-6">
                        <label for="password">
                          <span class="required">*</span> Senha:
                        </label>
                        <input
                          autocomplete="new-password"
                          type="password"
                          id="password"
                          class="form-control"
                          v-model="users.senha"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="confirmPassword">
                          <span class="required">*</span> Confirme a senha:
                        </label>
                        <input
                          autocomplete="new-password"
                          class="form-control"
                          id="confirmPassword"
                          type="password"
                          v-model="users.senha_confirmacao"
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="userPic">Foto do Perfil</label>
                      <div class="user-img">
                        <img
                          v-if="previewImage"
                          :src="previewImage"
                          class="photo"
                        />
                        <img v-else class="photo" />
                      </div>
                      <input
                        type="file"
                        id="userPic"
                        accept="image/*"
                        name="userPic"
                        @change="uploadImage"
                      />
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>

                    <div class="block text-right">
                      <router-link to="/users" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <button type="submit" class="btn btn-add">
                        Salvar
                        <i class="fa fa-save"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",

  data() {
    return {
      change_password: true,
      cpfLoginMode: false,
      cpfLogin: "",
      originalLogin: "",
      cpfError: "",
      _cpfModeInit: false,
      users: {
        usuario_nome: "",
        login: "",
        perfil_id: null,
        group_id: null,
        company_id: null,
        unit_ids: [],
        senha: "",
        senha_confirmacao: "",
        acessos_ip: "",
        cpf: "",
        status: true,
      },
      perfil_usuarios: [],
      groups: [],
      companies: [],
      units: [],
      errors: undefined,
      previewImage: null,
    };
  },

  computed: {
    loggedUser() {
      return this.$store.state.auth?.user || this.$store.state.user || null;
    },

    loggedCompanyName() {
      if (!this.isGestorLogged && !this.isGestorOperacionalLogged) {
        return "";
      }

      const company = this.companies.find(
        (company) => Number(company.id) === Number(this.users.company_id)
      );

      return company ? company.name : "";
    },

    isAdminLogged() {
      return Number(this.loggedUser?.perfil_id) === 1;
    },

    isGestorLogged() {
      return Number(this.loggedUser?.perfil_id) === 6;
    },

    isGestorOperacionalLogged() {
      return Number(this.loggedUser?.perfil_id) === 7;
    },

    filteredPerfis() {
      if (this.isAdminLogged) {
        return this.perfil_usuarios;
      }

      if (this.isGestorLogged) {
        return this.perfil_usuarios.filter(
          (perfil) => Number(perfil.perfil_id) !== 1
        );
      }

      // Gestor Operacional só pode atribuir Usuário (2) e Gestor Operacional (7)
      if (this.isGestorOperacionalLogged) {
        return this.perfil_usuarios.filter((perfil) =>
          [2, 7].includes(Number(perfil.perfil_id))
        );
      }

      return [];
    },

    filteredCompanies() {
      return this.companies;
    },

    filteredGroups() {
      if (!this.users.company_id) {
        return [];
      }

      return this.groups.filter((group) => {
        return String(group.company_id) === String(this.users.company_id);
      });
    },

    statusBoolean: {
      get() {
        return (
          this.users.status === true ||
          this.users.status === "1" ||
          this.users.status === 1
        );
      },
      set(value) {
        this.users.status = value;
      },
    },

    filteredUnits() {
      if (!this.users.company_id) {
        return [];
      }

      return this.units.filter(
        (unit) => String(unit.company_id) === String(this.users.company_id)
      );
    },

    allUnitsSelected() {
      if (!this.filteredUnits.length) {
        return true;
      }
      return (
        this.users.unit_ids &&
        this.users.unit_ids.length === this.filteredUnits.length
      );
    },
  },

  watch: {
    cpfLoginMode(val) {
      if (this._cpfModeInit) {
        this._cpfModeInit = false;
        return;
      }
      if (val) {
        this.originalLogin = this.users.login;
        this.cpfError = "";
      } else {
        this.users.login = this.originalLogin;
        this.cpfLogin = "";
        this.cpfError = "";
      }
    },
  },

  methods: {
    applyCpfMask(value) {
      const digits = String(value).replace(/\D/g, "").slice(0, 11);
      if (digits.length <= 3) return digits;
      if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
      if (digits.length <= 9)
        return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
      return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(
        6,
        9
      )}-${digits.slice(9)}`;
    },

    onCpfInput(e) {
      const masked = this.applyCpfMask(e.target.value);
      this.cpfLogin = masked;
      e.target.value = masked;
    },

    validateSelectedGroup() {
      if (!this.users.group_id) {
        return;
      }

      const exists = this.filteredGroups.some(
        (group) => Number(group.group_id) === Number(this.users.group_id)
      );

      if (!exists) {
        this.users.group_id = null;
      }
    },

    onGroupChange() {
      const group = this.groups.find(
        (g) => Number(g.group_id) === Number(this.users.group_id)
      );
      if (group && Array.isArray(group.units) && group.units.length > 0) {
        this.users.unit_ids = group.units.map((u) => u.id);
      } else if (!this.users.group_id) {
        this.users.unit_ids = [];
      }
    },

    selectAllUnits() {
      this.users.unit_ids = this.filteredUnits.map((u) => u.id);
    },

    onChangeUnits() {
      // manter compatibilidade, sem limpar o grupo
    },
    toggleFormSenha() {
      this.change_password = !this.change_password;
    },

    onChangeCompany() {
      this.users.unit_ids = [];
      this.users.group_id = null;
    },

    getLoggedUserCompany() {
      if (!this.loggedUser?.usuario_id) {
        return;
      }

      const api = this.$store.state.api + "users/" + this.loggedUser.usuario_id;

      axios
        .get(api)
        .then((response) => {
          const data = Array.isArray(response.data.data)
            ? response.data.data[0]
            : response.data.data;

          if (data && data.company_id) {
            this.users.company_id = Number(data.company_id);
          }
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    applyLoggedCompanyToUser() {
      if (
        (!this.isGestorLogged && !this.isGestorOperacionalLogged) ||
        !this.loggedUser?.company_id
      ) {
        return;
      }

      this.users.company_id = Number(this.loggedUser.company_id);
    },

    makeFormData() {
      this.applyLoggedCompanyToUser();

      let fd = new FormData();
      let photo = document.getElementById("userPic");

      fd.append("usuario_nome", this.users.usuario_nome);
      fd.append("login", this.users.login);
      fd.append("perfil_id", this.users.perfil_id ?? "");
      fd.append("group_id", this.users.group_id ? this.users.group_id : "");
      fd.append(
        "company_id",
        this.users.company_id ? this.users.company_id : ""
      );
      fd.append(
        "acessos_ip",
        this.users.acessos_ip ? this.users.acessos_ip : ""
      );
      fd.append("cpf", this.users.cpf ? this.users.cpf : "");
      if (!this.users.id || this.change_password) {
        fd.append("senha", this.users.senha);
        fd.append("senha_confirmacao", this.users.senha_confirmacao);
      }

      fd.append("status", this.statusBoolean ? "1" : "0");

      if (Array.isArray(this.users.unit_ids)) {
        if (this.users.unit_ids.length > 0) {
          this.users.unit_ids.forEach((id, index) => {
            fd.append(`unit_ids[${index}]`, id);
          });
        } else {
          // Enviar marcador para limpar todas as unidades
          fd.append("unit_ids_clear", "1");
        }
      }

      fd.append("_method", "POST");
      fd.append("foto", photo && photo.files[0] ? photo.files[0] : "");

      if (this.users.id) {
        fd.append("id", this.users.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },

    save() {
      if (this.cpfLoginMode) {
        const digits = this.cpfLogin.replace(/\D/g, "");
        if (digits.length !== 11) {
          this.cpfError =
            "CPF inválido. Informe um CPF completo com 11 dígitos.";
          return;
        }
        this.cpfError = "";
        this.users.login = digits;
      }

      let api = this.$store.state.api + "users";
      let fd = this.makeFormData();

      if (this.users.id) {
        api += "/" + this.users.id;
      }

      axios
        .post(api, fd)
        .then(() => {
          this.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          this.$router.push("/users");
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getUsers(id) {
      if (!id || id === "undefined") {
        return;
      }

      const api = this.$store.state.api + "users/" + id;

      axios
        .get(api, {
          params: {
            with: ["company", "units"],
          },
        })
        .then((response) => {
          const data = Array.isArray(response.data.data)
            ? response.data.data[0]
            : response.data.data;

          if (!data) {
            this.$message(
              "Erro",
              "Usuário não encontrado ou sem permissão",
              "error"
            );
            this.$router.push("/users");
            return;
          }

          this.users = {
            ...this.users,
            ...data,
            senha: "",
            senha_confirmacao: "",
            company_id: data.company_id ? Number(data.company_id) : null,
            group_id: data.group_id ? Number(data.group_id) : null,
            unit_ids: Array.isArray(data.units)
              ? data.units.map((unit) => unit.id)
              : [],
          };

          this.validateSelectedGroup();
          this.change_password = false;

          if (/^\d{11}$/.test(data.login)) {
            this.originalLogin = "";
            this.cpfLogin = this.applyCpfMask(data.login);
            this._cpfModeInit = true;
            this.cpfLoginMode = true;
          } else {
            this.originalLogin = data.login || "";
            this.cpfLogin = "";
            this._cpfModeInit = true;
            this.cpfLoginMode = false;
          }

          if (this.isGestorLogged) {
            this.applyLoggedCompanyToUser();
          }
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getPerfilUsuario() {
      let api =
        this.$store.state.api + "perfil_usuarios?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          this.perfil_usuarios = response.data.data;
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getGroups() {
      let api = this.$store.state.api + "groups?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          this.groups = response.data.data;
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
      this.validateSelectedGroup();
    },

    getCompanies() {
      const api = this.$store.state.api + "companies?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          this.companies = response.data.data;

          if (this.isGestorLogged && this.companies.length > 0) {
            this.users.company_id = Number(this.companies[0].id);
          }
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getUnits() {
      const api = this.$store.state.api + "units?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          this.units = response.data.data;
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
      this.validateSelectedGroup();
    },

    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (event) => {
        this.previewImage = event.target.result;
      };
    },
  },

  mounted() {
    this.getPerfilUsuario();
    this.getGroups();
    this.getCompanies();
    this.getUnits();

    if (this.isGestorLogged || this.isGestorOperacionalLogged) {
      this.getLoggedUserCompany();
    }

    const id = this.$route.params.id;
    if (id) {
      this.change_password = false;
      this.getUsers(id);
    }
  },

  components: {
    BaseCrud,
    vSelect,
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>